"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Categories = exports.default = void 0;
const react_1 = __importStar(require("react"));
const ramda_1 = require("ramda");
const categories_expansion_item_component_1 = require("./categories-expansion-item.component");
const generic_1 = require("../../../generic");
const localization_1 = require("../../../localization");
const components_1 = require("..");
const sidebar_section_1 = require("../side-bar/sidebar-section");
const Categories = ({ expansionCategories, isCategoriesLoading, openCategories, onHeaderClick, onCollapseAll, onExpandAll, className, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const isNoData = !expansionCategories.length && !isCategoriesLoading;
    const isOpenCategoriesEmpty = (0, react_1.useMemo)(() => (0, ramda_1.all)((value) => !value, (0, ramda_1.values)(openCategories)), [openCategories]);
    const isCollapsed = isNoData || isOpenCategoriesEmpty;
    return (react_1.default.createElement(components_1.SidebarSection, { className: className, title: react_1.default.createElement(react_1.default.Fragment, null, t({ key: 'CATEGORIES' }), react_1.default.createElement(sidebar_section_1.StyledCollapseAll, { onClick: isCollapsed ? onExpandAll : onCollapseAll }, t({ key: isCollapsed ? 'EXPAND_ALL' : 'COLLAPSE_ALL' }))) }, react_1.default.createElement(generic_1.Loading, { iconOrientation: "right", isLoading: isCategoriesLoading, progressSize: 25, showEllipsis: false }), !isCategoriesLoading && expansionCategories.map(({ id, subCategories, title }) => (react_1.default.createElement(categories_expansion_item_component_1.CategoriesExpansionItem, { key: id, id: id, title: title, items: subCategories, isOpen: openCategories[id], onHeaderClick: onHeaderClick })))));
};
const MemoizedCategories = react_1.default.memo(Categories);
exports.default = MemoizedCategories;
exports.Categories = MemoizedCategories;
